const binding = { modules: {}, dataActions: {} };

    (binding.modules['cus-public-asset-preload'] = {
        c: () => require('partner/modules/cus-public-asset-preload/cus-public-asset-preload.tsx'),
        $type: 'scriptModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'cus-public-asset-preload',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/cus-public-asset-preload'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };